export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/ryan-profile-2dcde743d8f7100e85fe487d5065d027.png";